import { COOKIE_NAME_SITE_ID } from '../../../core/js/constants';
import Cookies from '../../../core/js/services/cookies';

module.exports = {
    cache: {
        defaultExpiryTime: 60000,           // 6000 ms = 1 min
        defaultJSPExpiryTime: 180000        // 180000 ms = 30 mins
    },
    debug: false,
    googleMaps: {
        version: '3.17'
    },
    location: {
        origin: window.location.protocol + '//' + window.location.host,
        root: '/',
        contextPath: ''
    },
    pagination: {
        defaultItemsPerPage: 20
    },
    responsive: {
        smallScreenWidth: 640
    },
    scene7: {
        imagePath: '//images.anthropologie.com/is/image/Anthropologie/',
        videoPath: '//images.anthropologie.com/is/content/Anthropologie/Video/'
    },
    siteId: Cookies.getCookieByName(COOKIE_NAME_SITE_ID),
    sterlingBrandCodes: {
        'an-de': '07',
        'an-eu': '07',
        'an-fr': '07',
        'an-uk': '07',
        'an-us': '01'
    }
};
